import React from 'react'
import '.././popup.common.css'
import styles from './Style.module.css'
import CustomModal from '../../Modal/CustomModal'
import BorderedButton from '../../Buttons/BorderedButton'
import PrimaryButton from '../../Buttons/PrimaryButton'

const DiscardPopup = ({onClose, onCancel, onDiscard}) => {
  return (

    <CustomModal
        show={true}
        onHide={onClose}
        hideCloseButton={true}
    >
        <div className={`popup ${styles.discardPopup}`}>	
            <div className="header">
                <h2>There are unsaved changes, are you sure you want to discard them.</h2>
            </div>

            <div className="body">
                
            </div>

            <div className="footer">
                <BorderedButton
                    text="Keep Editing"
                    onClick={onCancel}
                />
                <PrimaryButton
                    text="Discard"
                    onClick={onDiscard}
                />
            </div>
        </div>
  </CustomModal>
  )
}

export default DiscardPopup